import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/layout/Logo";
import { CLINIC } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/doctor", label: "Doctor" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="sticky top-0 z-50 glass border-b border-border" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <Logo className="h-14 w-14" />
          <div className="leading-tight">
            <div className="font-serif text-xl text-foreground">Manasvi Dental</div>
            <div className="text-[11px] tracking-widest uppercase text-muted-foreground">Kota • Since Care</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) => `text-sm tracking-wide transition-colors ${isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${CLINIC.phone}`} className="hidden lg:flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground" data-testid="nav-phone">
            <Phone className="w-4 h-4" /> {CLINIC.phone}
          </a>
          <Link to="/book">
            <Button className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground px-6" data-testid="nav-book-btn">Book Appointment</Button>
          </Link>
        </div>

        <button className="md:hidden text-foreground" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background px-6 py-4 space-y-3" data-testid="mobile-menu">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} className="block py-2 text-foreground" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</NavLink>
          ))}
          <Link to="/book" className="block">
            <Button className="w-full rounded-full bg-primary text-primary-foreground" data-testid="mobile-book-btn">Book Appointment</Button>
          </Link>
        </div>
      )}
    </header>
  );
}
